import React, { useState, useEffect } from "react";
import Nav from "./Nav";
import axios from "axios";
import Loader from "../user/Loader";
import { BiAddToQueue } from "react-icons/bi";
import { FaUserCheck } from "react-icons/fa";

const ServiceQueue = () => {
    let date = new Date();
    let splittedDate = date.toISOString().split(/[a-zA-Z]+/g);


    const [serviceQueue, setServiceQueue] = useState([]);
    const [open, setOpen] = useState(false);
    const [services, setServices] = useState([])
    const [locations, setLocations] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchQueue, setSearchQueue] = useState([]);
    const [searchDate, setSearchDate] = useState(splittedDate[0]);
    const pages = [];
    const [pageNumberLimit, setPageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setMinPageNumberLimit] = useState(1);
    const [emptyQueueText, setEmptyQueueText] = useState("");
    const [dateInputErrorMessage, setDateInputErrorMessage] = useState("");

    const indexOfLastPost = currentPage * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;
    const currentPosts = searchQueue.slice(indexOfFirstPost, indexOfLastPost);


    const fetchData = () => {
        const listOfServices = axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_SERVICE_LIST_URL);
        const listOfLocations = axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_CAMPUS_LIST_URL);

        axios.all([listOfServices, listOfLocations])
            .then(axios.spread((...data) => {
                const serviceData = data[0];
                const locationData = data[1];
                setServices(serviceData.data);
                setLocations(locationData.data);
            }))
    }

    const getService = (serviceId) => {
        let serviceTitle = "";

        for (let service of services) {
            if (service.serviceId === serviceId) {
                serviceTitle = service.service_description;
                break;
            }
        }
        return serviceTitle;
    }

    const getLocation = (locationId) => {
        let locationTitle = "";
        for (let location of locations) {
            if (location.locationId === locationId) {
                locationTitle = location.campusLocation;
                break;
            }
        }
        return locationTitle;
    }


    const handleClick = (event) => {
        event.preventDefault();
        setCurrentPage(Number(event.target.id));
        window.scrollTo(0, 0);

    }
    const handleNextBtn = () => {
        if (currentPage + 1 > maxPageNumberLimit) {
            setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit);
            setCurrentPage(currentPage + 1);
            window.scrollTo(0, 0);

        }
        else {
            setCurrentPage(currentPage + 1);
            window.scrollTo(0, 0);
        }
    }

    const handlePrevBtn = () => {

        if (currentPage - 1 < minPageNumberLimit) {
            setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit);
            setCurrentPage(currentPage - 1);
            window.scrollTo(0, 0);
        }
        else {
            setCurrentPage(currentPage - 1);
            window.scrollTo(0, 0);
        }

    }

    let morePagesLeft = null;
    let morePagesRight = null;


    for (let i = 1; i <= Math.ceil(searchQueue.length / postPerPage); i++) {
        pages.push(i);
    }
    if (!(minPageNumberLimit == 1)) {
        morePagesLeft = <li className="navigation-link" >&hellip;</li>
    }
    if (pages.length > maxPageNumberLimit) {
        morePagesRight = <li className="navigation-link">&hellip;</li>
    }

    const renderQueue = pages.map(number => {
        if (number < maxPageNumberLimit + 1 && number >= minPageNumberLimit) {
            return (
                <li
                    key={number}
                    id={number}
                    onClick={handleClick}
                    className={currentPage == number ? "activePage" : "navigation-link"}
                >
                    {number}
                </li>
            )
        }
        else {
            return null;
        }

    })

    const filterByDate = (queue) => {
        let time = queue.slot.split(/[a-zA-Z]+/g);
        let date = time[0];
        if (date === searchDate) {
            return queue;
        }
    }
    const filterByLocation = (queue) => {
        let location = parseInt(localStorage.getItem("location"));
        if(queue.locationId === location){
            return queue;
        }
    }
    const handleOnChange = (event) => {
        event.preventDefault();
        let date = event.target.value.split("-");
        let year = date[0]
        let month = date[1]
        let day = date[2]
        let formatedDate = year + "-" + month + "-" + day;
        setSearchDate(formatedDate);
    }
    const handleOnSubmit = () => {

        if (searchDate === "") {
            setDateInputErrorMessage("Enter a valid input!!!!");
        }
        else if(serviceQueue.filter(filterByDate).length === 0) {
            setEmptyQueueText("Empty");
            setDateInputErrorMessage("");
            setSearchQueue([]);
        }
        else {
            setDateInputErrorMessage("")
            setSearchQueue(serviceQueue.filter(filterByDate));
        }
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };


    useEffect(() => {
        handleToggle();
        fetchData();
        handleClose();
        axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_RESERVATION_LIST_URL)
            .then((res) => {
                console.log(res.data)
                if (res.data.length === 0){
                    setEmptyQueueText("Empty");
                    setSearchQueue([]);
                }
                else {
                    setServiceQueue(res.data.filter(filterByLocation));
                    if (res.data.filter(filterByLocation).filter(filterByDate).length === 0) {
                        setEmptyQueueText("Empty");
                        setSearchQueue([]);
                    }
                    else {
                        setEmptyQueueText("");
                        setSearchQueue(res.data.filter(filterByLocation).filter(filterByDate));
                    }
                }
            })
            .catch(err => {
            })

    }, [])


    return (
        <div className="service-staff-body">
            <Nav 
                headerText="STAFF" 
                nav1="Service Queue" 
                nav2="Code Verification" 
                path2="/verify" 
                path1="/serviceQueue" 
                icon2={<BiAddToQueue />} 
                icon1={<FaUserCheck />} 
            />
            <div className="body">
                <div className="student-data-container">
                    <div className="header-container">
                        <h2>SERVICE QUEUE</h2>
                    </div>
                    <hr />
                    <div className="search-wrapper">
                        <div className="search-container">
                            <input
                                type="date"
                                className="date"
                                onChange={handleOnChange}
                            />
                            <input
                                type="submit"
                                className="search"
                                onClick={handleOnSubmit}
                            />
                            <p className="error">{dateInputErrorMessage}</p>
                        </div>

                    </div>

                    <div className="data-queue-container">
                        {searchQueue.length != 0 ?
                            <table className="data-inner-container">
                                <tr>
                                    <th className="table-head">Date</th>
                                    <th className="table-head">Time</th>
                                    <th className="table-head">Student Name</th>
                                    <th className="table-head">Matric Number</th>
                                    <th className="table-head">Service</th>
                                    <th className="table-head">Department</th>
                                    <th className="table-head">Campus Location</th>

                                </tr>
                                {currentPosts.map(queue => {
                                    let timeFrom = queue.slot.split(/[a-zA-Z]+/g);
                                    let currentDate = timeFrom[0].split("-");
                                    let formatedDate = currentDate[2] + "-" + currentDate[1] + "-" + currentDate[0];
                                    let time = timeFrom[1];


                                    return <tr key={queue.studentId}>
                                        <td className="table-data">{formatedDate}</td>
                                        <td className="table-data">{time}</td>
                                        <td className="table-data">{queue.surname + " " + queue.otherName}</td>
                                        <td className="table-data">{queue.matricNo}</td>
                                        <td className="table-data">{getService(queue.serviceId)}</td>
                                        <td className="table-data">{queue.department}</td>
                                        <td className="table-data">{getLocation(queue.locationId)}</td>
                                    </tr>
                                }

                                )
                                }
                            </table> : <h1>{emptyQueueText}</h1>}
                    </div>

                </div>

                <div className="navigation-wrapper" style={searchQueue.length > postPerPage ? { display: "block" } : { display: "none" }}>
                    <ul className="navigation-ul">
                        <li
                            onClick={handlePrevBtn}
                            className={currentPage == 1 ? "disabled" : "navigation-link"}
                        >
                            Prev
                        </li>
                        {morePagesLeft}
                        {renderQueue}
                        {morePagesRight}
                        <li
                            onClick={handleNextBtn}
                            className={currentPage === Math.ceil(searchQueue.length / postPerPage) ? "disabled" : "navigation-link"}>
                            Next
                        </li>
                    </ul>
                </div>

            </div>
            <Loader state={open} />
        </div>


    )
}
export default ServiceQueue;